var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoachingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0CD69C45-E459-4B7A-95B3-3F6AB8CD1847") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coaching-Sessions",
    transform: "translate(-28.000000, -164.000000)",
    fill: "#F88801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Nav",
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coaching-active",
    transform: "translate(28.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9831992,4.40272656 L4.21327734,4.40272656 C3.88983984,4.40272656 3.62733984,4.14061719 3.62733984,3.81678906 C3.62733984,3.49335156 3.88983984,3.23085156 4.21327734,3.23085156 L10.9831992,3.23085156 C11.3066367,3.23085156 11.5691367,3.49335156 11.5691367,3.81678906 C11.5691367,4.14061719 11.3066367,4.40272656 10.9831992,4.40272656 M10.9831992,7.13710156 L4.21327734,7.13710156 C3.88983984,7.13710156 3.62733984,6.87499219 3.62733984,6.55116406 C3.62733984,6.22772656 3.88983984,5.96522656 4.21327734,5.96522656 L10.9831992,5.96522656 C11.3066367,5.96522656 11.5691367,6.22772656 11.5691367,6.55116406 C11.5691367,6.87499219 11.3066367,7.13710156 10.9831992,7.13710156 M13.829293,0.0390546875 L2.26171484,0.0390546875 C1.01444922,0.0390546875 -3.90625e-06,1.05350781 -3.90625e-06,2.30077344 L-3.90625e-06,12.4374922 C-3.90625e-06,12.9175703 0.542925781,13.1881953 0.926167969,12.9144453 L4.14765234,10.6160078 C4.41796484,10.4234297 4.73593359,10.3214766 5.06796484,10.3214766 L12.1535117,10.3214766 C13.4007773,10.3214766 14.4152305,9.30702344 14.4152305,8.05975781 L14.4152305,0.624992187 C14.4152305,0.301554687 14.1527305,0.0390546875 13.829293,0.0390546875",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.84569531 L20,16.9820234 C20,17.4588594 19.4598047,17.7346797 19.0738281,17.4589766 L15.8523437,15.1609297 C15.5820312,14.9683516 15.2640625,14.8663984 14.9320312,14.8663984 L7.84648437,14.8663984 C6.59921875,14.8663984 5.58476562,13.8515547 5.58476562,12.6042891 L5.58476562,11.4933125 L12.1535156,11.4933125 C14.046875,11.4933125 15.5871094,9.95311719 15.5871094,8.05975781 L15.5871094,4.58358594 L17.7382812,4.58358594 C18.9855469,4.58358594 20,5.59842969 20,6.84569531",
    id: "Fill-4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachingActive);
export default __webpack_public_path__ + "static/media/coaching-active.47c163e0.svg";
export { ForwardRef as ReactComponent };